<template>
    <div class="Page">
        <Header></Header>
        <div class="MaxWid">
            <!-- <p>123</p> -->
            <updateRegistration v-if="typeId == 2" :id="id" :uid="uid" :mode="mode"/>
            <userExercises v-else :id="id" :uid="uid" :mode="mode"/>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/header/head';
import Footer from '@/components/header/footer';
import Banner from '@/components/banner/Banner';
import updateRegistration from '@/components/updateRegistration/DoingExercises.vue';
import userExercises from '@/components/updateRegistration/userExercises.vue';
export default {
    components: { Header, Footer, Banner, updateRegistration,userExercises },
    data() {
        return {
            typeId: null,
            id: null,
            uid: null,
            mode: 'create',
        }
    },
    created() {
        this.id = this.$route.query.id;
        this.uid = this.$route.query.uid;
        this.mode = this.$route.query.mode || 'create';
    },
    mounted() {
        this.typeId = this.$route.query.typeId;
    },
    methods: {

    },
}
</script>
<style scoped>
.Page {
    background: #fff;
}

.MaxWid {
    max-width: 1180px;
    padding: 0 10px;
    margin: 0 auto;
}
</style>